<template>
    <div class="profiles-landing-container">
        <div id="preloader" v-if="load" class="preloader"></div>
        <div class="profiles-wrapper">
            <p class="title">My Pages</p>
            <div class="divider"></div>
            <section v-if="artists.length" class="artist-pages">
                <p class="title">My Artist pages</p>
                <div class="artists">
                    <Artist
                        v-for="(user, indx) in artists"
                        :key="indx"
                        :artist="user"
                        :selectable="true"
                        :cta="'View Page'"
                        :card-styles="{
                            border: 'none !important'
                        }"
                    />
                </div>
            </section>
            <section v-if="venues.length" class="venue-pages">
                <p class="title">My Venue pages</p>
                <div class="venues">
                    <Venue
                        v-for="(user, indx) in venues"
                        :key="indx"
                        :user="user"
                        :cta="'View Page'"
                    />
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    import { api } from '@/helpers/api'
    import Artist from '@/components/search-result-artist/Artist.vue'
    import Venue from '@/components/search-result-venue/Venue.vue'

    const URLS = {
        xhr: {
            fetch: {
                booker: '/api/profile/v1/user-profile/booker-info'
            }
        }
    }

    export default {
        name: 'ProfilesLanding',
        components: { Artist, Venue },
        props: {
            booker: {
                required: true
            },
            currentUser: {
                required: true
            }
        },
        data: () => ({
            load: false,
            bookerInfo: {}
        }),
        computed: {
            URLS() {
                return URLS
            },
            artists() {
                if (!this.bookerInfo.artistPages) {
                    return []
                }
                return this.bookerInfo.artistPages
            },
            venues() {
                if (!this.bookerInfo.venuePages) {
                    return []
                }
                return this.bookerInfo.venuePages
            }
        },
        methods: {
            async fetchBookerInfo() {
                try {
                    this.load = true
                    const data = await api({
                        method: 'get',
                        url: `${URLS.xhr.fetch.booker}/${this.booker}`
                    })
                    return data.data
                } finally {
                    this.load = false
                }
            }
        },
        watch: {
            artistInfo: function (artist) {
                if (artist.archivable === undefined || artist.archivable === null) {
                    return
                }
                this.populateProfiles(artist, 'artist')
            },
            venueInfo: function (venue) {
                if (venue.archivable === undefined || venue.archivable === null) {
                    return
                }
                this.populateProfiles(venue, 'venue')
            },
            profilesInfo: function (profiles) {
                let active = []
                let archived = []

                for (let i = 0; i < profiles.length; i++) {
                    if (profiles[i].archived) {
                        archived.push(profiles[i])
                    } else {
                        active.push(profiles[i])
                    }
                }

                this.activeProfiles = active
                this.archivedProfiles = archived
            }
        },
        async created() {
            this.bookerInfo = await this.fetchBookerInfo()
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .profiles-landing-container {
        width: 100%;
        max-width: 1168px;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding-left: 60px;
        padding-right: 60px;
        gap: 20px;

        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }
        .title {
            color: #dedede;
            @include base-font-44;
            line-height: 110%;
            letter-spacing: -1.76px;
        }
        .divider {
            background: rgba(255, 255, 255, 0.14);
            height: 1px;
            width: 100%;
            margin-top: 10px;
            margin-bottom: 10px;
        }

        .artist-pages,
        .venue-pages {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 24px;

            .title {
                color: #dedede;
                @include base-font-28;
                font-weight: 600;
                line-height: 32px;
            }
            .artists,
            .venues {
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: flex-start;
                gap: 20px;
                flex-wrap: wrap;
                overflow-x: auto;
                padding-bottom: 10px;

                @media screen and (max-width: 768px) {
                    flex-wrap: nowrap;
                }
            }
            .artists::-webkit-scrollbar,
            .venues::-webkit-scrollbar {
                height: 4px;
            }
            .artists::-webkit-scrollbar-track,
            .venues::-webkit-scrollbar-track {
                background-color: none;
            }
            .artists::-webkit-scrollbar-thumb,
            .venues::-webkit-scrollbar-thumb {
                max-height: 64px;
                border-radius: 8px;
                background: #8b8b8b;
            }
        }
    }
</style>
